import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BenefitsDetail } from '../../../models/benefits.model';

@Component({
  selector: 'app-fmx-info',
  templateUrl: './fmx-info.component.html',
  styleUrls: ['./fmx-info.component.scss']
})
export class FMXInfoComponent implements OnInit {
  @Input() itemsCoreData: any;
  @Input() enableAvailability: boolean = true;
  @Input() enableEdit: boolean = true;
  @Input() enableDelete: boolean = true;
  @Input() hasIntro: boolean = false;
  @Input() mantenienceSection;
  @Output() itemAvailability: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemCreate: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemEdit: EventEmitter<any> = new EventEmitter<any>();


  constructor() {
  }

  ngOnInit(): void {
  }

  sendItemAvailability(itemId: number): void {
    this.itemAvailability.emit(itemId);
  }

  sendItemCreate(): void {
    this.itemCreate.emit(true);
  }

  sendItemEdit(item: any): void {
    this.itemEdit.emit(item);
  }

  sendItemDelete(itemId: number) {
    this.itemDelete.emit(itemId);
  }
}
